module.exports = __webpack_public_path__ + "img/zeitleiste-zoom-minus.8fcd21b1.svg";